import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router';

import BasePage from "../components/base/BasePage";

import Login from "../views/login/Login.vue";
import Index from "../views/index/Index.vue";

const Score = () => import('../views/score/Score');
const ScoreList = () => import('../views/score/ScoreList');

const Param = () => import('../views/param/Param');
const ParamList = () => import('../views/param/ParamList');

const BlackList = () => import('../views/black/BlackList');
const BlackAreaList = () => import('../views/black/BlackAreaList');
const BlackAreaConfig = () => import('../views/black/BlackAreaConfig');
const IDFABlackList = () => import('../views/black/IDFABlackList');
const DIDBlackList = () => import('../views/black/DIDBlackList');

const Withdraw = () => import('../views/withdraw/Withdraw');
const WithdrawList = () => import('../views/withdraw/WithdrawList');
const WithdrawError = () => import('../views/withdraw/WithdrawError');
const OrderList = () => import('../views/withdraw/OrderList');

const Record = () => import('../views/record/Record');
const ScoreRecordList = () => import('../views/record/ScoreRecordList');
const EcpmRecordList = () => import('../views/record/EcpmRecordList');
const BalanceRecordList = () => import('../views/record/BalanceRecordList');

const Sign = () => import('../views/sign/Sign');
const SignList = () => import('../views/sign/SignList');
const SignRecordList = () => import('../views/sign/SignRecordList');

const Task = () => import('../views/task/Task');
const RookieTaskList = () => import('../views/task/RookieTaskList');
const DailyTaskList = () => import('../views/task/DailyTaskList');
const WatchTaskList = () => import('../views/task/WatchTaskList');
const GoodReviewTaskList = () => import('../views/task/GoodReviewTaskList');
const TaskRecordList = () => import('../views/task/TaskRecordList');

const Exclusive = () => import('../views/task/Exclusive');
const ExclusiveMissionList = () => import('../views/task/ExclusiveMissionList');
const ExclusiveRecordList = () => import('../views/task/ExclusiveRecordList');

const White = () => import('../views/white/White');
const WhiteList = () => import('../views/white/WhiteList');

const NoticeAdd = () => import('../views/notice/NoticeAdd');
const Notice = () => import('../views/notice/Notice');
const NoticeList = () => import('../views/notice/NoticeList');

const AppConfig = () => import('../views/appConfig/AppConfig');
const AdTypeConfig = () => import('../views/appConfig/AdTypeConfig');
const AppConfigList = () => import('../views/appConfig/AppConfigList');
const ExtFieldList = () => import('../views/appConfig/ExtFieldList');
const WxPayConfigList = () => import('../views/appConfig/WxPayConfigList');

const User = () => import('../views/user/User');
const UserList = () => import('../views/user/UserList');

const MarkUserList = () => import('../views/user/MarkUserList');

const IpList = () => import('../views/user/IpList');
const PersonalCenter = () => import('../views/user/PersonalCenter');
const InviterList = () => import('../views/user/InviterList');
const InviteeList = () => import('../views/user/InviteeList');
const AddressList = () => import('../views/user/AddressList');
const AddressList1 = () => import('../views/user/AddressList1');

const TotalRecord = () => import('../views/totalRecord/TotalRecord');
const TotalRecordList = () => import('../views/totalRecord/TotalRecordList');
const Dashboard = () => import('../views/totalRecord/Dashboard');

const Test = () => import('../views/zTest/Test');
const TestList = () => import('../views/zTest/TestList');


const File = () => import('../views/file/File');
const FileList = () => import('../views/file/FileList');


const routes = [


    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/pages',
        component: BasePage,
        children: [

            {
                path: '/pages/index/index',
                name: 'Index',
                component: Index
            },

            {
                path: "user",
                name: 'User',
                component: User,
                children: [

                    {
                        path: "userList",
                        name: "UserList",
                        component: UserList,
                    },
                    {
                        path: "blackList",
                        name: "BlackList",
                        component: BlackList,
                    },
                    {
                        path: "ipList",
                        name: "IpList",
                        component: IpList,
                    },
                    {
                        path: "inviterList",
                        name: "InviterList",
                        component: InviterList,
                    },
                    {
                        path: "inviteeList",
                        name: "InviteeList",
                        component: InviteeList,
                    },
                    {
                        path: "addressList",
                        name: "AddressList",
                        component: AddressList,
                    },
                    {
                        path: "markUserList",
                        name: "MarkUserList",
                        component: MarkUserList,
                    },



                    {
                        path: "addressList1",
                        name: "AddressList1",
                        component: AddressList1,
                    },

                ]
            },

            {
                path: "black",
                name: 'Black',
                component: White,
                children: [
                    {
                        path: "blackList",
                        name: "BlackList",
                        component: BlackList,
                    },
                    {
                        path: "blackAreaList",
                        name: "BlackAreaList",
                        component: BlackAreaList,
                    },

                    {
                        path: "iDFABlackList",
                        name: "IDFABlackList",
                        component: IDFABlackList,
                    },
                    {
                        path: "dIDBlackList",
                        name: "DIDBlackList",
                        component: DIDBlackList,
                    },
                    {
                        path: "blackAreaConfig",
                        name: "BlackAreaConfig",
                        component: BlackAreaConfig,
                    },




                ]
            },
            {
                path: "white",
                name: 'White',
                component: White,
                children: [
                    {
                        path: "whiteList",
                        name: "WhiteList",
                        component: WhiteList,
                    },
                ]
            },
            {
                path: "test",
                name: 'Test',
                component: Test,
                children: [
                    {
                        path: "testList",
                        name: "TestList",
                        component: TestList,
                    },
                ]
            },
            {
                path: "param",
                name: 'Param',
                component: Param,
                children: [
                    {
                        path: "paramList",
                        name: "ParamList",
                        component: ParamList,
                    },
                ]
            },
            {
                path: "record",
                name: 'Record',
                component: Record,
                children: [
                    {
                        path: "recordList",
                        name: "RecordList",
                        component: ScoreRecordList,
                    },
                    {
                        path: "ecpmRecordList",
                        name: "EcpmRecordList",
                        component: EcpmRecordList,
                    },
                    {
                        path: "balanceRecordList",
                        name: "BalanceRecordList",
                        component: BalanceRecordList,
                    },
                ]
            },
            {
                path: "score",
                name: 'Score',
                component: Score,
                children: [
                    {
                        path: "scoreList",
                        name: "ScoreList",
                        component: ScoreList,
                    },
                ]
            },
            {
                path: "withdraw",
                name: 'Withdraw',
                component: Withdraw,
                children: [
                    {
                        path: "withdrawList",
                        name: "WithdrawList",
                        component: WithdrawList,
                    },
                    {
                        path: "withdrawError",
                        name: "WithdrawError",
                        component: WithdrawError,
                    },

                    {
                        path: "orderList",
                        name: "OrderList",
                        component: OrderList,
                    },


                ]
            },

            {
                path: "notice",
                name: 'Notice',
                component: Notice,
                children: [
                    {
                        path: "noticeAdd",
                        name: "NoticeAdd",
                        component: NoticeAdd,
                    },
                    {
                        path: "noticeList",
                        name: "NoticeList",
                        component: NoticeList,
                    },
                ]
            },

            {
                path: "appConfig",
                name: 'AppConfig',
                component: AppConfig,
                children: [

                    {
                        path: "extFieldList",
                        name: "ExtFieldList",
                        component: ExtFieldList,
                    },

                    {
                        path: "appConfigList",
                        name: "AppConfigList",
                        component: AppConfigList,
                    },

                    {
                        path: "wxPayConfigList",
                        name: "WxPayConfigList",
                        component: WxPayConfigList,
                    },

                    {
                        path: "adTypeConfig",
                        name: "AdTypeConfig",
                        component: AdTypeConfig,
                    },
                ]
            },
            {
                path: "task",
                name: 'Task',
                component: Task,
                children: [
                    {
                        path: "rookieTaskList",
                        name: "RookieTaskList",
                        component: RookieTaskList,
                    },
                    {
                        path: "watchTaskList",
                        name: "WatchTaskList",
                        component: WatchTaskList,
                    },
                    {
                        path: "dailyTaskList",
                        name: "DailyTaskList",
                        component: DailyTaskList,
                    },
                    {
                        path: "goodReviewTaskList",
                        name: "GoodReviewTaskList",
                        component: GoodReviewTaskList,
                    },


                    {
                        path: "taskRecordList",
                        name: "TaskRecordList",
                        component: TaskRecordList,
                    },
                ]
            },

            {
                path: "sign",
                name: 'Sign',
                component: Sign,
                children: [
                    {
                        path: "signList",
                        name: "SignList",
                        component: SignList,
                    },
                    {
                        path: "signRecordList",
                        name: "SignRecordList",
                        component: SignRecordList,
                    },
                ]
            },

            {
                path: "exclusive",
                name: 'Exclusive',
                component: Exclusive,
                children: [
                    {
                        path: "exclusiveMissionList",
                        name: "ExclusiveMissionList",
                        component: ExclusiveMissionList,
                    },
                    {
                        path: "exclusiveRecordList",
                        name: "ExclusiveRecordList",
                        component: ExclusiveRecordList,
                    },
                ]
            },

            {
                path: "totalRecord",
                name: 'TotalRecord',
                component: TotalRecord,
                children: [
                    {
                        path: "totalRecordList",
                        name: "TotalRecordList",
                        component: TotalRecordList,
                    },
                    {
                        path: "dashboard",
                        name: "Dashboard",
                        component: Dashboard,
                    },

                ]
            },

            {
                path: "file",
                name: 'File',
                component: File,
                children: [
                    {
                        path: "fileList",
                        name: "FileList",
                        component: FileList,
                    }
                ]
            },


            {
                path: "personalCenter",
                name: 'PersonalCenter',
                component: PersonalCenter,
            },
        ]
    },

];


// const router = new createRouter({
//     mode: 'hash', // history
//     routes: [],
//     ...routes: constantRoutes
// })


// const router = new createRouter({
//     history: createWebHashHistory (),
//     mode: 'hash',
//     routes: routes
// });

const router = new createRouter({
    // history: createWebHistory(),
    history: createWebHashHistory(),
    mode: 'hash',
    routes
});

export default router;



